import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/apiClient";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/subscribe", { email });
      toast.success("You're on the list — watch for launch deals!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-obsidian/15 bg-obsidian text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        {/* Newsletter */}
        <div className="mb-14 grid gap-6 border-b border-white/10 pb-12 md:grid-cols-2 md:items-center">
          <div>
            <h3 className="font-serif text-3xl font-light tracking-tight">Get launch deals & new drops</h3>
            <p className="mt-2 max-w-md text-sm text-white/55">
              Join the list for early access to new products and subscriber-only discount codes.
            </p>
          </div>
          <form onSubmit={subscribe} className="flex gap-2" data-testid="newsletter-form">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="min-w-0 flex-1 border border-white/20 bg-transparent px-4 py-3 text-sm text-white placeholder-white/40 focus:border-signal focus:outline-none"
            />
            <button
              data-testid="newsletter-submit"
              type="submit"
              disabled={loading}
              className="inline-flex shrink-0 items-center gap-2 bg-signal px-5 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:bg-red-700 disabled:opacity-60"
            >
              {loading ? "…" : <>Join <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>
        </div>

        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="font-serif text-3xl font-medium tracking-tighter">
              LUX<span className="text-signal">•</span>DROP
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              Premium digital products for freelancers and solo creators. Instant delivery,
              lifetime access, zero fluff.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Store</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>AI Packs</li>
              <li>E-books</li>
              <li>Business</li>
              <li>Bundles</li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Company</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>About</li>
              <li>License</li>
              <li>Support</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 text-xs uppercase tracking-[0.15em] text-white/40">
          © 2026 LuxDrop — Built for creators
        </div>
      </div>
    </footer>
  );
};
